/** Explicit game balance, independent of the fixed simulation clock. */
export const MILITARY_BALANCE = {
  deploymentPace: 2,
  hostileHealth: 10,
  hostileOrdnance: 12,
  hostileFireRate: 2,
  eliteCount: 200,
  eliteHealth: 12,
  eliteWeaponPower: 3,
  eliteFireRate: 3,
  eliteSpeed: 4.6,
};
